// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Messages":"co_a bhb_a bhb_w","Messages__hasSeen":"co_b bhb_p"};